<mat-button-toggle-group [(ngModel)]="filterMode" (valueChange)="onToggleChanged($event)">
  <mat-button-toggle value="last12">Letzte 12 Stunden</mat-button-toggle>
  <mat-button-toggle value="trackingDate">An Buchungsdatum</mat-button-toggle>
</mat-button-toggle-group>

<div style="margin-top: 1rem">
  <ng-container *ngIf="trackings$ | async as trackings">
    <ng-container *ngIf="trackings.length > 0">
      <ng-container *ngFor="let res of resources$ | async">
        <div class="user-title" *ngIf="getUserBookings(trackings, res) as userTrackings">
          <p4m-expandable-card-component titleClass="user-container">
            <ng-container class="card-title">
              <div class="title-container">{{ getSum(userTrackings, res) | number: '1.0-2' }}h
                <span>{{ res }}</span>
                <span class="tag employee">Mitarbeiter</span>
                <span>{{ userTrackings[0].RUECKMELDER_NAME }}</span>
              </div>
            </ng-container>

            <ng-container class="card-content">
              <div class="tracking-table-wrapper">
                <p4m-tracking-table [trackings]="userTrackings"></p4m-tracking-table>
              </div>
            </ng-container>
          </p4m-expandable-card-component>
        </div>

        <div class="machine-title" *ngIf="getMachineBookings(trackings, res) as machineTrackings">
          <p4m-expandable-card-component titleClass="machine-container">
            <ng-container class="card-title">
              <div class="title-container">{{ getSum(machineTrackings, res) | number: '1.0-2' }}h
                <span>{{ res }}</span>
                <span class="tag machine">Maschine</span>
                <span>{{ machineTrackings[0]?.RUECKMELDER_NAME }}</span>
              </div>

            </ng-container>

            <ng-container class="card-content">
              <div class="tracking-table-wrapper">
                <p4m-tracking-table [trackings]="machineTrackings"></p4m-tracking-table>
              </div>
            </ng-container>
          </p4m-expandable-card-component>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

</div>
